import { QuoteReservation } from '@/models/quote'
import { getBoughtServicesTotal } from './timeSchedules'

// This util is necessary to keep track of
// 1) amount of a single specific service added to cart
// 2) amount of the same single service selected on the current open spot in SelectedElementDrawer
// the end goal is to avoid surpassing the service limit and prevent overbooking
export const sumServiceQuantityInCart = ({
  cartReservations,
  selectedElementCartReservation,
  serviceId,
}: {
  cartReservations: QuoteReservation[]
  selectedElementCartReservation?: QuoteReservation
  serviceId: number
}) => {
  return cartReservations
    .filter(
      (reservation) =>
        reservation.boughtServices[serviceId] &&
        (reservation.spotName !== selectedElementCartReservation?.spotName ||
          reservation.spotType !== selectedElementCartReservation?.spotType)
    )
    .reduce((sum, reservation) => {
      return sum + getBoughtServicesTotal(reservation.boughtServices[serviceId])
    }, 0)
}
